import { Code as CodeToExtend } from '@tiptap/extension-code';

export const Code = CodeToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: null
        }
    }
})
